module.exports = __webpack_public_path__ + "static/media/Aladdin-Sane@2x.02aad0a3.png";